import { AuthGuard } from './../guards/auth.guard';
import { DietasComponent } from './dietas.component';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CadastrarDietasDeactivateGuard } from './../guards/c-dietas-deactivate.guard';

const rotas: Routes = [    
    {
        path: '',
        component: DietasComponent,
        canActivate: [AuthGuard]
    },    
    {
        path: 'cadastrar',
        loadChildren: './cadastrar/cadastrar.module.ts#DietasCadastrarModule',
        canDeactivate: [CadastrarDietasDeactivateGuard]
    },
    {
        path: 'cadastrar/paciente/:codPaciente',
        loadChildren: './cadastrar/cadastrar.module.ts#DietasCadastrarModule',
        canDeactivate: [CadastrarDietasDeactivateGuard]
    },
    {
        path: 'editar/dieta/:codDieta',
        loadChildren: './cadastrar/cadastrar.module.ts#DietasCadastrarModule',
        canDeactivate: [CadastrarDietasDeactivateGuard]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(rotas)
    ],
    exports: [
        RouterModule
    ]
})

export class DietasRotasModule {}



// WEBPACK FOOTER //
// ./src/app/dietas/dietas.rotas.module.ts